import { useEffect } from "react";
import { useCookies } from "react-cookie";

export const SELECTED_PLACE_COOKIE = "v_selected_place_id";

export function useSelectedPlace(user: User | null, isAdmin?: boolean) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [cookies, setCookie, removeCookie] = useCookies([
    SELECTED_PLACE_COOKIE,
  ]);

  const availablePlaces = [
    user?.adminForPlace,
    ...(user?.managedPlaces || []),
  ].filter(Boolean) as any[];

  const selectedPlaceId = cookies[SELECTED_PLACE_COOKIE];

  useEffect(() => {
    if (!isAdmin)
      if (user && availablePlaces.length > 0 && !selectedPlaceId) {
        const defaultPlace = user?.adminForPlace || availablePlaces[0];
        if (defaultPlace) {
          setCookie(SELECTED_PLACE_COOKIE, String(defaultPlace.id), {
            path: "/",
            maxAge: 86400,
          });
        }
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, availablePlaces, selectedPlaceId, setCookie]);

  const selectedPlace =
    availablePlaces.find((p) => p.id === selectedPlaceId) || availablePlaces[0];

  const setSelectedPlaceId = (placeId: string) => {
    setCookie(SELECTED_PLACE_COOKIE, placeId, { path: "/", maxAge: 86400 });
  };

  return {
    selectedPlace,
    selectedPlaceId,
    availablePlaces,
    setSelectedPlaceId,
  };
}
